module.exports = __webpack_public_path__ + "img/logo-caishen.78d07f4d.png";